import React from 'react';

export const renderCSVTable = (csvData, theme) => {
  const rows = csvData.split('\n').map(row => row.split(','));
  return renderTable(rows, theme);
};

export const renderArrayTable = (tableData, theme) => {
  return renderTable(tableData, theme);
};

const renderTable = (rows, theme) => {
  
  return (
    <div className="ui-scroll overflow-x-auto rounded-lg border border-ui-line">
      <table className="min-w-full table-auto border-collapse">
        <thead>
          <tr>
            {rows[0].map((header, headerIndex) => (
              <th 
                key={headerIndex} 
                className="px-3 py-2 text-left text-xs font-semibold whitespace-nowrap"
                style={{
                  borderBottom: `1px solid ${theme.colors.tableBorder || theme.colors.cardBorder}`,
                  backgroundColor: theme.colors.tableHeaderBackground || theme.colors.surfaceElevated,
                  color: theme.colors.tableHeaderText || theme.colors.text
                }}
              >
                {String(header).trim()}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.slice(1).map((row, rowIndex) => (
            <tr key={rowIndex} className="[&:last-child>td]:border-b-0">
              {row.map((cell, cellIndex) => (
                <td 
                  key={cellIndex} 
                  className="px-3 py-2 text-sm"
                  style={{
                    borderBottom: `1px solid ${theme.colors.tableBorder || theme.colors.cardBorder}`,
                    backgroundColor: theme.colors.tableCellBackground || theme.colors.cardBackground,
                    color: theme.colors.tableCellText || theme.colors.textSecondary
                  }}
                >
                  {String(cell).trim()}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}; 